import { PipeTransform, Pipe } from '@angular/core';
import merge from 'lodash-es/merge';

@Pipe({name: 'chartSwitchData'})
export class ChartSwitchData implements PipeTransform {
	transform(data, chartGroupType) : any {
		if (chartGroupType === 'relative') {
			let newData = Array.isArray(data) ? merge([], data) : merge({}, data);
			
			if (data.length > 0) {
				let xLen     = data[0].length,
					totalLen = data.length,
					totals   = [0];
				
				for(let i=1; i<xLen; i++) {
					let total = 0;
					for(let j=1; j<totalLen; j++) {
						total += <number>data[j][i];
					}
					totals.push(total);
				}
				
				for(let i=1; i<xLen; i++) {
					for(let j=1; j<totalLen; j++) {
						newData[j][i] = 100 * data[j][i] / totals[i];
					}
				}
			}
			
			return newData;
		} else {
			return data;
		}
	}
}

